import Toggle from './upload-google'

export default Toggle
